// extracted by mini-css-extract-plugin
export var readonly = "_i8-1";
export var star = "_i8-0";